// import { BOOL, getSelector } from './helpers';

window.WebComponent('mega-menu', {
  props: ['visibility'],

  connected() {
    this.bind();
  },

  methods: {
    onVisibility(_, value) {},

    bind() {
      // teleport <mega-menu>
      const { $el } = this;
      if ($el.dataset.teleport !== 'true') {
        const { SiteHeader: $header } = window;
        this.$el.dataset.teleport = true;
        $header.appendChild(this.$el);
      } else return;

      // bind events
      setTimeout(() => this.bindEvents(), 100);
    },

    bindEvents() {
      const { $el } = this;
      const $menus = $el.querySelectorAll('.menu-link');

      $el.addEventListener('mouseleave', () => {
        // hiding open menus
        this.toggle();
      });

      $menus.forEach(($menu) => {
        const $mobileTarget = $menu.querySelector('.mobile-click-target');
        $mobileTarget.addEventListener('click', (e) => {
          const hasChildren = this.hasNoChildrens($menu);
          if (hasChildren) e.preventDefault();

          this.onMenu($menu);
        });

        $menu.addEventListener('mouseenter', () => {
          if ($mobileTarget.checkVisibility()) return;
          this.onMenu($menu);
        });
      });

      const [
        $levelsWrapper,
        $l1Wrapper,
        $l2Wrapper,
        $l3Wrapper,
        $currentTitle,
      ] = $el.querySelectorAll(
        '.levels, .level-1-set, .level-2-set, .level-3-set, .mobileheader-title',
      );

      this.$levelsWrapper = $levelsWrapper;
      this.$l1Wrapper = $l1Wrapper;
      this.$l2Wrapper = $l2Wrapper;
      this.$l3Wrapper = $l3Wrapper;
      this.$currentTitle = $currentTitle;

      this.setCurrentState(0);

      const $backBtn = $el.querySelectorAll('.go-back');
      $backBtn.forEach(($btn) => {
        $btn.addEventListener('click', () => this.goBack());
      });

      // assigning target event on links
      const $links = document.querySelectorAll('[data-menu]');
      $links.forEach(($link) => {
        const { megamenuTarget } = $link.dataset;
        const $desktopTrigger = $link.querySelector('.megamenu__target');

        if ($desktopTrigger) {
          $desktopTrigger?.addEventListener('mouseenter', () =>
            this.toggle(megamenuTarget),
          );
          $link.addEventListener('click', () => {
            const isOpen = this.$el.classList.contains('--visible');
            this.toggle(!isOpen ? megamenuTarget : '');
          });
        } else $link.addEventListener('mouseenter', () => this.toggle());
      });
    },

    emmit(isopen = true) {
      const ev = new Event('@menu-change');
      ev.details = { isopen };
      window.dispatchEvent(ev);
    },

    toggle(megamenuTarget) {
      // hiding open menus
      const $openMegamenu = document.querySelector('mega-menu.--visible');
      $openMegamenu?.classList?.remove('--visible');

      // no megamenu
      if (!megamenuTarget) {
        // restore scroll
        document.body.style.removeProperty('overflow');
        this.emmit(false);
        return;
      }

      // open hovered menu
      const menu = document.querySelector(`mega-menu#${megamenuTarget}`);
      menu.classList.add('--visible');

      this.$el.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`,
      );

      // prevent scroll
      document.body.style.setProperty('overflow', 'hidden');

      this.emmit(true);
    },

    goBack() {
      const { $levelsWrapper } = this;
      const currentLevel =
        $levelsWrapper.style.getPropertyValue('--current-level');

      this.setCurrentState(currentLevel - 1);
    },

    setCurrentState(level) {
      const { $levelsWrapper } = this;
      $levelsWrapper.style.setProperty('--current-level', level);
      $levelsWrapper.dataset.currentLevel = level;

      const { $l1Wrapper, $l2Wrapper, $currentTitle } = this;
      if (level === 1) {
        const { title } = $l1Wrapper.querySelector(
          '.menu-link.--selected',
        )?.dataset;
        $currentTitle.innerHTML = title;
      } else if (level === 2) {
        const { title } = $l2Wrapper.querySelector(
          '.menu-link.--selected',
        )?.dataset;
        $currentTitle.innerHTML = title;
      }
    },

    hasNoChildrens($menu) {
      const { dataset } = $menu;
      const { hierarchy = '' } = dataset;
      const hset = hierarchy.split('-');

      const children = this.$el.querySelector(
        `[data-hierarchy-parent="${hset.join('-')}"`,
      );
      return !!children;
    },

    onMenu($menu) {
      const { dataset } = $menu;
      const { hierarchy = '' } = dataset;
      const [l1, l2, l3] = hierarchy.split('-');

      // if user is on level 3 menu
      if (l3) return;

      const { $levelsWrapper, $l1Wrapper, $l2Wrapper, $l3Wrapper } = this;
      if (l2) {
        // clear previous selection
        $l3Wrapper
          .querySelector('.--current-menus')
          ?.classList.remove('--current-menus');
        $l3Wrapper?.classList?.remove('--current-level');

        // clear menu highlight
        $l2Wrapper
          ?.querySelector('.menu-link.--selected')
          ?.classList.remove('--selected');

        const $submenu = $l3Wrapper.querySelector(
          `[data-hierarchy-parent="${l1}-${l2}"]`,
        );
        if ($submenu) {
          $submenu?.classList.add('--current-menus');
          $l3Wrapper?.classList.add('--current-level');

          // show menu selected
          $menu.classList.add('--selected');

          // for mobile
          this.setCurrentState(2);
        }
      } else if (l1) {
        // clear previous selection
        $l2Wrapper
          ?.querySelector('.--current-menus')
          ?.classList?.remove('--current-menus');
        $l2Wrapper?.classList?.remove('--current-level');
        $l3Wrapper?.classList?.remove('--current-level');

        // clear menu highlight
        $l2Wrapper
          ?.querySelector('.menu-link.--selected')
          ?.classList.remove('--selected');
        $l1Wrapper
          ?.querySelector('.menu-link.--selected')
          ?.classList.remove('--selected');

        const $submenu = $l2Wrapper.querySelector(
          `[data-hierarchy-parent="${l1}"]`,
        );
        if ($submenu) {
          $submenu?.classList.add('--current-menus');
          $l2Wrapper.classList.add('--current-level');

          // show menu selected
          $menu.classList.add('--selected');

          // for mobile
          this.setCurrentState(1);
        } else this.setCurrentState(0);
      }
    },
  },
});
